import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';


export interface SimpleDialogData {
  title?: string;
  message: string;
  ok: string;
  cancel?: string;
  required?: boolean;
  inputType?: string;
  inputValue?: string;
}

export interface SimpleDialogResultValue {
  submitted: boolean;
  value: string | null;
}

export type SimpleDialogResult = undefined | SimpleDialogResultValue;

@Component({
  templateUrl: 'simple-dialog.component.html',
  styleUrls: ['simple-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    FormsModule,
    MatFormField,
    MatInput,
    MatDialogActions,
    MatButton,
  ],
})
export class SimpleDialogComponent {
  private dialogRef = inject<MatDialogRef<SimpleDialogComponent>>(MatDialogRef);
  data = inject<SimpleDialogData>(MAT_DIALOG_DATA);

  input: string | null = null;

  constructor() {
    const data = this.data;

    this.input = data.inputValue ?? null;
  }

  submit(submitted: boolean) {
    const result: SimpleDialogResult = { submitted, value: this.input?.trim() ?? null };
    this.dialogRef.close(result);
  }
}
